<div class="gridItemChildModule w-100 h-100 d-flex flex-column" id="coaching-body">
    <div class="header" id="coaching-header">
        <div class="coaching-category-filter-section d-flex flex-column align-items-center" id="coaching-tabs">
            <div class="w-100 px-2 d-flex flex-row justify-content-center" id="coaching-tabs-container">
                <button type="button" id="owned-by-me-btn" class="cxone-btn btn-big btn-secondary btn-bg-is-white"
                    [ngClass]="{'button-active': coachingCategory === 0}" cvLocalizedText
                    langSection="Coaching_Status_Module" langKey="Owned_By_Me" (click)="setCoachingCategory(0)">
                    Owned by me
                </button>
                <button type="button" id="assigned-to-me-btn" class="cxone-btn btn-big btn-secondary btn-bg-is-white"
                    [ngClass]="{'button-active':coachingCategory === 1}" cvLocalizedText
                    langSection="Coaching_Status_Module" langKey="Assigned_To_Me" (click)="setCoachingCategory(1)">
                    Assigned to me
                </button>
            </div>
        </div>
    </div>

    <div class="coaching-status-chart-content" id="chart-container">
        <app-module-error [noData]="true" *ngIf="noData" id="no-data-error"></app-module-error>
        <cv-loader size="large" *ngIf="!chartConfig && !noData"></cv-loader>
        <canvas *ngIf="chartConfig && !noData" id="coaching-pie-chart" baseChart width="400px" height="225px"
            [type]="chartConfig.type" [legend]="chartConfig.options.plugins.legend"
            [datasets]="chartConfig.data.datasets" [labels]="chartConfig.data.labels" [options]="chartConfig.options"
            [plugins]="chartConfig.plugins">
        </canvas>
        <div class="nav-links" id="nav-links">
            <ng-container *ngIf="coachingCategory === 0; else elseTemplate" id="coaching-manager-container">
                <span *ngIf="cXOneCoachingManagerAccess" id="coaching-manager-link" class="curPoint" cvLocalizedText
                    [langSection]="'Coaching_Status_Module'" [langKey]="'View_Coaching_Manager'"
                    (click)="navigate()">View coaching Manager</span>
            </ng-container>
            <ng-template #elseTemplate id="coaching-session-container">
                <span id="coaching-session-link" class="curPoint" cvLocalizedText
                    [langSection]="'Coaching_Status_Module'" [langKey]="'View_Coaching_Sessions'"
                    (click)="navigate()">View coaching Sessions</span>
            </ng-template>
            <svg *ngIf="!(cXOneCoachingManagerAccess === false && coachingCategory === 0)" (click)="navigate()" class="icon-20 fill-iconDefault" id="new-window-icon">
                <use href="../App_Themes/CXone/icons/new-window.svg#new-window"></use>
            </svg>
        </div>
    </div>
</div>